<script lang="ts">
	import SubUnitManagement from 'src/components/Settings/HomeManagement/SubUnitManagement.svelte';
</script>

<SubUnitManagement />
